export default __webpack_public_path__ + "static/media/svglogo.ee607ac4.svg";